import React from 'react';
import { FaWhatsapp, FaTiktok, FaFacebook, FaEnvelope, FaPhone } from 'react-icons/fa';

const Footer = () => {
  const socialLinks = [
    {
      icon: <FaWhatsapp />,
      url: 'https://wa.me/27739130901',
      label: 'WhatsApp',
      color: '#25D366'
    },
    {
      icon: <FaTiktok />,
      url: 'https://tiktok.com/@yolaniphotoshoot',
      label: 'TikTok',
      color: '#000000'
    },
    {
      icon: <FaFacebook />,
      url: 'https://facebook.com/yolaniphotoshoot',
      label: 'Facebook',
      color: '#1877F2'
    }
  ];

  return (
    <footer id="contact" className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-info">
            <h3>Yolani's Photoshoot</h3>
            <p>Creating beautiful memories that last a lifetime</p>
            <div className="social-links">
              <h4>Follow Us</h4>
              <div className="social-icons">
                {socialLinks.map((social, index) => (
                  <a 
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                    aria-label={social.label}
                    style={{ '--social-color': social.color }}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
          
          <div className="footer-contact">
            <h4>Contact Us</h4>
            <div className="contact-item">
              <FaEnvelope className="contact-icon" />
              <span>info@yolaniphotoshoot.co.za</span>
            </div>
            <div className="contact-item">
              <FaPhone className="contact-icon" />
              <span>+27 73 913 0901</span>
            </div>
            <div className="contact-item">
              <FaWhatsapp className="contact-icon" style={{ color: '#25D366' }} />
              <span>WhatsApp: +27 73 913 0901</span>
            </div>
          </div>
          
          <div className="footer-booking">
            <h4>Ready to Book?</h4>
            <p>Contact us to schedule your photoshoot session</p>
            <div className="booking-buttons">
              <a 
                href="https://wa.me/27739130901?text=Hi! I'd like to book a photoshoot session with Yolani's Photoshoot."
                target="_blank"
                rel="noopener noreferrer"
                className="btn whatsapp-btn"
              >
                <FaWhatsapp /> Book via WhatsApp
              </a>
              <a href="mailto:info@yolaniphotoshoot.co.za" className="btn btn-secondary">
                <FaEnvelope /> Email Us
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2024 Yolani's Photoshoot. All rights reserved. | <a href="https://yolaniphotoshoot.co.za" style={{color: '#fecdd3'}}>yolaniphotoshoot.co.za</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;